import React from "react";
import { useMap } from "react-leaflet";
import { useLocation } from "react-router-dom";
import trans from "../../../../utils";

export default function ObjectMinimized({ title, name, minimize }) {
	const map = useMap();
	map.scrollWheelZoom.enable();
	let { pathname } = useLocation();
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div
				className={
					title === "object"
						? "object-minimized object-details"
						: `object-minimized object-selected  ${
								lang === "en" ? "object-selected-ltr" : "object-selected-rtl"
						  }`
				}
				role="button"
				onClick={minimize}
			>
				<div>
					{pathname === "/livetracking"
						? title === "object"
							? trans("Vehicles")
							: name
						: name
						? trans(name)
						: trans("geofences")}
				</div>
				<img
					src={`${process.env.PUBLIC_URL}/assets/${
						lang === "en" ? "Double-revarrow" : "Double-arrow"
					}.svg`}
					alt="doublearrow"
				/>
			</div>
		</>
	);
}
